import { render, staticRenderFns } from "./ExtratoCliente.vue?vue&type=template&id=50d54ba0&scoped=true&"
import script from "./ExtratoCliente.vue?vue&type=script&lang=js&"
export * from "./ExtratoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d54ba0",
  null
  
)

export default component.exports